import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Button } from '../../../components/Button';
import { FONTS } from '../../../constants';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { coaching_image } from '../../../assets/base64';

const LOREM =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

interface CoachingProps {
  onPressCoaching: () => void;
}

const Coaching: FC<CoachingProps> = ({ onPressCoaching }) => {
  const isDesktop = useIsDesktop();
  return (
    <View style={styles.wrapper}>
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onPress={onPressCoaching}
      >
        <View
          style={{
            width: 38,
            height: 1,
            backgroundColor: STYLE_VARS.primaryColor,
            marginRight: 3,
          }}
        />
        <Text
          style={{
            fontFamily: FONTS.IowanOldStyleBTRoman,
            color: STYLE_VARS.primaryColor,
            textAlign: 'center',
          }}
        >
          SPORTS
        </Text>
        <View
          style={{
            width: 38,
            height: 1,
            backgroundColor: STYLE_VARS.primaryColor,
            marginLeft: 3,
          }}
        />
      </TouchableOpacity>
      <Text
        style={{
          fontFamily: FONTS.IowanOldStyleBTRoman,
          fontSize: 24,
          color: STYLE_VARS.primaryColor,
          textAlign: 'center',
          marginBottom: 20,
        }}
        onPress={onPressCoaching}
      >
        COACHING
      </Text>

      <Image
        style={{
          width: '100%',
          height: 180,
        }}
        source={
          IS_WEB
            ? addBase64Prefix(coaching_image)
            : require('../../../assets/coaching_image.jpeg')
        }
        onPress={onPressCoaching}
      />

      <Text
        style={{
          textAlign: 'center',
          fontSize: 15,
          color: STYLE_VARS.primaryColor,
          marginVertical: 20,
          textTransform: 'uppercase',
        }}
        onPress={onPressCoaching}
      >
        BOOK SPORTS COACHING
      </Text>
      <View style={{ alignItems: 'center' }}>
        <Button
          text="BOOK NOW"
          style={STYLE_VARS.blueButton}
          onPress={onPressCoaching}
        />
      </View>
    </View>
  );
};

export default Coaching;

const styles = StyleSheet.create({
  wrapper: {
    marginVertical: 50,
  },
});
